import Success from './Success';
import Error from './Error';
import './Status.scss';

export default {
    Success,
    Error
};
